<template>
	<el-container>
		<Menu :activeIndex='activeIndex'></Menu>
		<el-container>
			<el-header>
				<h2>消息提示</h2>
			</el-header>
			<el-main>
				<!--<div class="tipContent">
					<el-button type="success" v-on:click="judgeClass" :loading="sendLoad">课程群发提醒</el-button>
				</div>-->
				<el-table :data="courseList" ref='singleTable' style="width: 100%;" :stripe="true" :border='true' :default-sort="{prop: 'date', order: 'descending'}">
					<el-table-column type="index" width="50"></el-table-column>
					<el-table-column label="课程" :show-overflow-tooltip="true" width="200">
						<template slot-scope="scope">
							<div class='class_row'>
								<span v-text="scope.row.name"></span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="src" label="封面" style="" width="100">
						<template slot-scope="scope">
							<img :src="scope.row.src" alt="" style="width: 50px;margin-top:5px;">
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="success" v-on:click="sendmsg(scope.row.id,scope.row.name,scope.$index)" :loading="scope.row.sendload">课程群发提醒</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination style="background:#fff;" :page-size="9" @current-change="handleCurrentChange" :current-page.sync="currentPage" layout="prev, pager, next" :total="courseTotal"></el-pagination>
			</el-main>
			<el-footer>Copyright &copy; Soren经济学人 技术支持 ：
				<a href="#">苏州西西弗斯商务信息咨询有限公司</a>
			</el-footer>
		</el-container>
		<div class="load_page" v-loading="loading" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-customClass="load_icon" v-show="loading"></div>
	</el-container>
</template>

<script>
	export default {
		data() {
			return {
				activeIndex: "5",
				new_today: '',
				sendLoad: false,
				courseList:[],
				loading:true,
				courseTotal:0,
				currentPage:1
			}
		},
		mounted() {
			this.getData();
			this.getDate();

		},
		updated: function() {

		},
		components: {

		},
		methods: {
			sendmsg:function(id,name,index){
				var self = this;
				self.courseList[index].sendload = true;
				self.axios.post('/wechat/pushToLearn', {
					mark: localStorage.getItem("mark"),
					"currentName": name,
            		"currentId":11
				})
				.then(function(response) {
					self.courseList[index].sendload = false;
					if(response.data.code == "600") {
						console.log(response)

					} else if(response.data.code == "400") {
						self.$message({
							type: "error",
							message: "操作失败"
						});
					}
				})
				.catch(function(error) {
					//console.log(error);
				});
			},
			handleCurrentChange:function(){
				this.getData()
			},
			getData:function(){
				var self = this;
				self.loading = true;
				self.axios.post('/course/list', {
					mark: localStorage.getItem("mark"),
					page: self.currentPage
				})
				.then(function(response) {
					if(response.data.code == "600") {
						self.loading = false;
						self.courseTotal = response.data.dataTotal;
						self.courseList = response.data.data;
						for(var i=0;i<self.courseList.length;i++){
							self.courseList[i].sendload = false;
							self.courseList[i].todaySend = false;
						}
					} else if(response.data.code == "400") {
						self.$message({
							type: "error",
							message: "操作失败"
						});
					}
				})
				.catch(function(error) {
					//console.log(error);
				});
			},
			getDate: function() {
				var that = this;
				var _date = new Date();
				var tempMonth = (_date.getMonth() + 1) < 10 ? '0' + (_date.getMonth() + 1) : (_date.getMonth() + 1);
				var tempDate = _date.getDate() < 10 ? '0' + _date.getDate() : _date.getDate();
				var new_today = _date.getFullYear() + '-' + tempMonth + '-' + tempDate;
				that.new_today = new_today;
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="scoped">
	.tipContent {
		padding: 20px;
		background: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/MessageTip.vue